module.exports = require("ngx-pagination");